/** Граница ошибок вокруг экрана.
 *
 * Без неё одна упавшая деталь гасит всё приложение до чёрного экрана — что и
 * случилось, когда фронт получил ответ API без ожидаемого поля. Такое бывает
 * штатно: у человека открыт старый бандл, а сервер уже обновился.
 *
 * Экран целиком дороже любой детали, поэтому здесь — не «красиво деградировать»,
 * а «остаться на ногах»: показать, что сломалось, и дать перезагрузиться.
 */
import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { failed: boolean };

export class Boundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // Консоль — единственное место, где это можно увидеть: телеметрии в продукте
    // нет и не планируется, он личный.
    console.error("экран упал:", error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ padding: "120px 26px 40px", textAlign: "center" }}>
        <h1 style={{ fontSize: "var(--f-t2)", fontWeight: 700, letterSpacing: "-0.3px",
                     margin: 0 }}>
          Экран не собрался
        </h1>
        <p style={{ fontSize: "var(--f-body)", color: "var(--text-muted)",
                    marginTop: "var(--s-3)", lineHeight: 1.6 }}>
          Скорее всего, приложение обновилось, пока оно было открыто. Записи целы —
          перезагрузи.
        </p>
        <button type="button" onClick={() => window.location.reload()}
                style={{ marginTop: "var(--s-5)", minHeight: "var(--tap)", padding: "14px 22px",
                         background: "var(--accent)", color: "var(--on-accent)", border: "none",
                         borderRadius: "var(--r-field)", fontSize: "var(--f-body)",
                         fontWeight: 600, cursor: "pointer", font: "inherit" }}>
          Перезагрузить
        </button>
      </div>
    );
  }
}
